import axios from 'axios';
import { combase } from '@/config';

export default {
  async postSendingContent(body) {
    try {
      const res = await axios.post(`${combase}post/api/v1/sending-content`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async postEmailService(body) {
    try {
      const res = await axios.post(`${combase}post/api/v1/email-service`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async postLineuserid(body) {
    try {
      const res = await axios.post(`${combase}post/api/v1/lineuserid`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async postCheckFriend(body) {
    try {
      const res = await axios.post(`${combase}post/api/v1/check-friend`, body);
      return res.data;
    } catch (err) {
      return err.response.data;
    }
  },
  async getChannel(params) {
    try {
      const res = await axios.post(`${combase}get/api/v1/channel`, {}, { params });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }
};
